<template>
	<div>
		<p class="title1">
			短信服务
		</p>
		<div class="count_nei1">
			<div class="cont_title"> 短信</div>
		</div>
		<a @click="jump('fasongjl')">
			<div class="sendJ">发送记录</div>
		</a>
		<div class="tongjxiao">
			<div class="row">
				<div class="col-md-3">
					<div class="tongjkk">
						<p class="Sum1 shengyu">{{database.surplus}}</p>
						<div class="progress" style="margin-bottom: 0;height: 7px">
							<div class="progress-bar progress-bar-success1 shengyurange" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" :style="'width:'+database.surplus+'%;'">
							</div>
						</div>
						<p class="Sum1sm">短信剩余条数</p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="tongjkk">
						<p class="Sum1 benzhou">{{database.week_counts}}</p>
						<div class="progress" style="margin-bottom: 0;height: 7px">
							<div class="progress-bar progress-bar-success2 zhoutongj " role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" :style="'width:'+database.week_counts+'%;'">
							</div>
						</div>
						<p class="Sum1bz">本周统计</p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="tongjkk">
						<p class="Sum1 benyuetongji">{{database.month_counts}}</p>
						<div class="progress" style="margin-bottom: 0;height: 7px">
							<div class="progress-bar progress-bar-success3 benyuetongji2" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" :style="'width:'+database.month_counts+'%;'">
							</div>
						</div>
						<p class="Sum1b2">本月统计</p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="tongjkk2">
						<a @click="jump('duanxinmob')">
							<div class="zisDs mart10">模板设置</div>
						</a>
						<a @click="jump('duanxinfasong')">
							<div class="zisDs mart36">短信发送</div>
						</a>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 100%;height: 70px;clear: both"></div>
		<div class="tubiaok">
			<div class="tubL">
				<p class="tubiaoTi">短信使用量</p>
				<div class="zhexk" id="e1"></div>
			</div>
			<div class="tubR">
				<div class="count_nei2">
					<div class="cont_title2">充值</div>
				</div>
				<a @click="jump('chongzhijl')">
					<div class="sendJ bor">充值记录</div>
				</a>
				<div>
					<div class="huanxk" id="e2"></div>
					<div class="chongzhi">
						<a @click="jump('chongzhi')">
							<div class="chongzhiBtn">充值</div>
						</a>
					</div>
				</div>
				<div style="clear: both"></div>
				<p class="tishi" v-show="tishi == 1">当前剩余充足，请放心使用</p>
				<p class="tishi" v-show="tishi==2">当前短信数量不足，请尽快充值</p>
			</div>
		</div>
	</div>
</template>

<script>
		export default{
			 data(){
			 	  return{
			 	  	 token:'',
			 	  	 database:'',//数据
			 	  	 echarts_number:[],
			 	  	 echarts_month:[],
                      tishi:1,

			 	  }
			 },
			 created(){
			 	this.token = this.$cookies.get('token');
			 },
			 methods:{
			 	  jump(u){
			 	  	 this.$router.push({path:u})
			 	  },
			 	  get_data(){
			 	  	 let that = this
			 	  	 $.ajax({
					   url: process.env.apiUrl + 'saas/dx/dxsurplus',
					   type: 'post',
					   data:{
					  	  token:that.token
					    },
					    success: function (data, status) {
					        if(data.status == 1){
					        	that.database = data.data
                                that.get_echarts2()
					        }
					        if(data.data.surplus > 200){
                                that.tishi = 1;
                            }else{
					            that.tishi = 2;
                            }
			 			},
					    fail: function (err, status) {
					        console.log(err)
					    }
					 })
			 	  },
			 	  get_data2(){
			 	  	 let that = this
			 	  	 $.ajax({
					   url: process.env.apiUrl + 'saas/dx/dxtu',
					   type: 'post',
					   data:{
					  	  token:that.token
					    },
					    success: function (data, status) {
					        if(data.status == 1){
					        	that.echarts_number = data.data.data
					        	that.echarts_month = data.data.month
                                that.get_echarts()
					        }
			 			},
					    fail: function (err, status) {
					        console.log(err)
					    }
					 })
			 	  },
                 //左边echarts
                 get_echarts(){
                     var myChart = echarts.init(document.getElementById('e1'));
                     var option = {
                         /* color: ['#76a6f0', '#00a0e9', '#f603ff', '#00b419', '#5f52a0'],*/
                         color: ['#E6BE8A'],
                         tooltip: {
                             trigger: 'item',
                             position: ["50%", "50%"]
                         },
                         xAxis: {
                             type: 'category',
                             boundaryGap: false,
                             splitLine: { //网格线
                                 show: false,
                                 lineStyle: {
                                     color: ['#b1b1b1'],
                                     type: 'dashed'
                                 }
                             },
                             data: this.echarts_month,
                         },
                         yAxis: {
                             splitLine: { //网格线
                                 show: true,
                                 lineStyle: {
                                     color: ['#b1b1b1'],
                                     type: 'dashed'
                                 }
                             }
                         },
                         series: [{
                             name: 'gymbaby',
                             type: 'line',
                             data: this.echarts_number,
                             label: {
                                 normal: {
                                     show: true,
                                     position: 'top' //值显示
                                 }
                             }
                         }]
                     };
                     myChart.setOption(option);
                     window.onresize = myChart.resize;
                 },
			 	  //右边echarts
			 	  get_echarts2(){
			 	  	    var myChart2 = echarts.init(document.getElementById('e2'));
						var option = {
							color: ['#dbdbdb','#fcb06a'],
							title: {
								text: this.database.number +'/'+this.database.use,
								textStyle: {
									color: '#666',
									fontSize: 16,
									fontWeight: 'normal',
									fontFamily: '华文细黑',
								},
								x: '35%',
								y: 'center'
							},
							legend: {
								show: false,
								x: 'left',
								y: 'bottom',
								data: ['已用', '剩余']
							},
							series: [{
								type: 'pie',
								radius: ['75%', '65%'],
								center: ['50%', '50%'],
								label: {
									normal: {
										show: false
									}
								},
								data: [{
										value: this.database.use-this.database.number,
										name: '已用'
									},
									{
										value: this.database.number,
										name: '剩余'
									}
								],
							}]
						};
						myChart2.setOption(option);
						window.onresize = myChart2.resize;
			 	  },

			 },
			 mounted(){
			 	this.get_data()
			 	this.get_data2()
			 }
		}
</script>

<style scoped>
    @import url("../../../static/qmsj/css/duanxin/chushiyangsh.css");
    @import url("../../../static/qmsj/css/duanxin/duanxinye1.css");

	p{
   		margin: 0;
        padding: 0;
    }
    a:link {text-decoration: none;color: #999} /* 未访问的链接 */
    a:visited {text-decoration: none;color: #999} /* 已访问的链接 */
    a:hover {text-decoration: none;color: #999} /* 当有鼠标悬停在链接上 */
    a:active {text-decoration: none;color: #999} /* 被选择的链接 */
</style>



// WEBPACK FOOTER //
// src/pages/duanxin/duanxin.vue